import {fitText} from './playUtil.es6';
import PackAddToCollectionAction from "./actions/PackAddToCollectionAction.es6";
import PackCloneAction from "./actions/PackCloneAction.es6";
import PackShareCommand from "./actions/PackShareAction.es6";
import ProgressButton from "./progressButton";
import Texter from "./texter.es6";
import CardSound from "./cardSound.es6";
import mapElementToValue from "./mapElementToValue.es6";
import stopEvent from "./stopEvent.es6";
import Modaller from "./modaller";
import {aPromise} from "./jqUtil.ts";
import {PackPagePromo} from "./packPagePromo.es6";
import {ChromeExtensionInstallPromo} from "./chromeExtensionSurvey/install.es6";

require('jsrender')($);

// const log = console.log;
const log = $.noop;
const promo = new ChromeExtensionInstallPromo();

CardSound.addReadyCallback($.noop);

const CARD_EMBED_ITEMS_TEMPLATE = $.templates(`
{{for cards}}
    <div class="fl-pack-embed__card" style="display:none;" data-card="{{:id}}">
        <div class="fl-pack-embed__card-face {{if faceImageSrc && faceText}}fl-pack-embed__card-side--image-and-text{{/if}}">
            {{if faceImageSrc}}
                <div class="fl-pack-embed__card-image"><img alt="{{attr:faceText}}" src="{{attr:faceImageSrc}}"></div>
            {{/if}}
            {{if faceText}}
            <div class="fl-pack-embed__card-text"><div class="fl-tt-{{: faceT == 1 ? 'html' : 'text'}}">{{if faceT == 1}}{{:faceText}}{{else}}{{>faceText}}{{/if}}</div></div>
            {{/if}}
        </div>
        <div class="fl-pack-embed__card-back {{if backImageSrc && backText}}fl-pack-embed__card-side--image-and-text{{/if}}">
            {{if backImageSrc}}
                <div class="fl-pack-embed__card-image"><img alt="{{attr:backText}}" src="{{attr:backImageSrc}}"></div>
            {{/if}}
            {{if backText}}
            <div class="fl-pack-embed__card-text"><div class="fl-tt-{{: backT == 1 ? 'html' : 'text'}}">{{if backT == 1}}{{:backText}}{{else}}{{>backText}}{{/if}}</div></div>
            {{/if}}
        </div>
    </div>
{{/for}}
`);

class CardEmbed {
    /**
     * @param view
     * @param {Texter} l18n
     * @param {MoreCardsProvider} moreCardsProvider
     */
    constructor(view, l18n, moreCardsProvider) {
        this.dataSource = moreCardsProvider;

        this.view = view;
        this.list = this.view.find('.fl-pack-embed__card');
        this.listSize = parseInt(this.view.data('count'));

        this.currentIndex = -1;
        this.current = null;

        this.textCurrent = view.find('span[data-bind=cardCurrent]');

        view.find('[data-click=cardFlip]').click(() => {
            this._flip();
            return false;
        });
        view.find('[data-click=cardPrev]').click(() => {
            this._showByIndex(this.currentIndex - 1);
            return false;
        });
        view.find('[data-click=cardNext]').click(() => {
            this._showByIndex(this.currentIndex + 1);
            return false;
        });

        this.start();
    }

    start() {
        if (this.list.length) {
            this._showByIndex(0);
        }
    }

    _showByIndex(index) {
        index = (index + this.listSize) % this.listSize;

        this._loadMore(index).finally(() => {
            if (this.current != null) {
                this.current.hide();
                this.current = null;
                this.currentIndex = -1;
            }

            this.current = $(this.list.get(index));
            this.currentIndex = index;
            this.currentSide = 'face';
            this.current.show();
            CardEmbed._showSide(this.current, this.currentSide);

            this.textCurrent.text('' + (index + 1) + ' / ' + this.listSize);
        });
    }

    _loadMore(indexNeeded) {
        // не надо загружать полный список, если все что надо пока есть, или неоткуда загружать
        if (indexNeeded < this.list.length || this.dataSource == null) {
            return Promise.resolve();
        }

        const knownCount = this.list.length;
        return this.dataSource.load()
            .then(
                list => {
                    const addition = list
                        .filter((value, index) => index >= knownCount);

                    const html = CARD_EMBED_ITEMS_TEMPLATE.render({
                        cards: addition
                    }, this);

                    this.view.find('.fl-pack-embed__field').append(html);
                    this.list = this.view.find('.fl-pack-embed__card');
                },
                () => {
                })
            .finally(() => {
                this.dataSource = null;
            })
    }

    static _showSide(card, side) {
        card.find('.fl-pack-embed__card-face').toggle(side === 'face');
        card.find('.fl-pack-embed__card-back').toggle(side !== 'face');

        const sideView = side === 'face'
            ? card.find('.fl-pack-embed__card-face')
            : card.find('.fl-pack-embed__card-back');

        const sideText = sideView.find('.fl-pack-embed__card-text > div');
        if (!sideText.hasClass('fitted')) {
            fitText(sideText);
            sideText.addClass('fitted');
        }

        const sideImage = sideView.find('.fl-pack-embed__card-image > img');
        if (sideImage.length && !sideImage.hasClass('fitted')) {
            sideImage.fitImage();
            sideImage.addClass('fitted');
        }
    }

    _flip() {
        if (this.current == null) {
            return;
        }

        if (this.currentSide === 'face') {
            this.currentSide = 'back';
            CardEmbed._showSide(this.current, this.currentSide);
        } else {
            this._showByIndex(this.currentIndex + 1);
        }
    }
}

const CARD_PREVIEW_ITEMS_TEMPLATE = $.templates(`
{{for cards ~authenticated=authenticated}}
<li id="plist_card_{{:id}}" data-id="{{:id}}" class="fl-pack-plist__item panel
{{if difficult}}fl-pack-plist__item--difficult{{/if}}
{{if familiar}}fl-pack-plist__item--familiar{{/if}}
{{if mastered}}fl-pack-plist__item--mastered{{/if}}
{{if starred}}fl-pack-plist__item--starred{{/if}}
{{if banned}}fl-pack-plist__item--banned{{/if}}
"
                            itemprop="workExample" itemscope itemtype="http://schema.org/Question">
                            <div class="fl-pack-plist__flags">
                                {{if familiar}}<span>{{>~l18n.get('packPage.list.filter.familiar')}}</span>{{/if}}
                                {{if mastered}}<span>{{>~l18n.get('packPage.list.filter.mastered')}}</span>{{/if}}
                                {{if difficult}}<span>{{>~l18n.get('packPage.list.filter.difficult')}}</span>{{/if}}
                                {{if banned}}<span>{{>~l18n.get('packPage.list.filter.banned')}}</span>{{/if}}
                                <div class="fl-pack-plist__flags-line">
                                    {{if ~authenticated}}
                                        <button type="button" class="btn btn-light" data-click="plistToggleFavourite"><span class="fa{{if !starred}}l{{/if}} fa-star"></span></button>
                                    {{/if}}
                                    <button type="button" class="btn btn-light" data-click="plistPlayAudio"><span class="fal fa-volume"></span></button>
                                </div>
                            </div>
                            <div class="fl-pack-plist__face clearfix" data-lang="{{attr:faceL}}">
                                {{if faceA}}<audio src="{{attr:faceA}}"></audio>{{/if}}
                                {{if faceImageSrc}}<div class="fl-pack-plist__image"><img alt="{{attr:faceText}}" src="{{attr:faceImageSrc}}"></div>{{/if}}
                                <div class="fl-tt-{{: faceT == 1 ? 'html' : 'text'}}"  itemprop="text">{{if faceT == 1}}{{:faceText}}{{else}}{{>faceText}}{{/if}}</div>
                            </div>
                            <div class="fl-pack-plist__back clearfix" data-lang="{{attr:backL}}" itemprop="acceptedAnswer" itemscope itemtype="http://schema.org/Answer">
                                {{if backA}}<audio src="{{attr:backA}}"></audio>{{/if}}
                                {{if backImageSrc}}<div class="fl-pack-plist__image"><img alt="{{attr:backText}}" src="{{attr:backImageSrc}}"></div>{{/if}}
                                <div class="fl-tt-{{: backT == 1 ? 'html' : 'text'}}"  itemprop="text">{{if backT == 1}}{{:backText}}{{else}}{{>backText}}{{/if}}</div>
                            </div>
                        </li>
{{/for}}
`);

class CardPreviewListItem {
    constructor(id) {
        this.id = id;
        this.li_ = null;
        this.sortAlpha = '';
    }

    get li() {
        if (this.li_ == null) {
            this.li_ = $(`#plist_card_${this.id}`);
        }
        return this.li_;
    }

    set li(value) {
        this.li_ = value;
    }
}

const CARD_FLAG_STARRED = 1;
const CARD_FLAG_DIFFICULT = 1 << 1;
const CARD_FLAG_FAMILIAR = 1 << 2;
const CARD_FLAG_MASTERED = 1 << 3;
const CARD_FLAG_BAN = 1 << 4;

const SORT_ORIGINAL = 'original';
const SORT_ALPHA = 'alpha';

function createCardFlagEntry(id, flag) {
    return {
        id: id,
        difficult: (flag & CARD_FLAG_DIFFICULT) === CARD_FLAG_DIFFICULT,
        mastered: (flag & CARD_FLAG_MASTERED) === CARD_FLAG_MASTERED,
        familiar: (flag & CARD_FLAG_FAMILIAR) === CARD_FLAG_FAMILIAR,
        starred: (flag & CARD_FLAG_STARRED) === CARD_FLAG_STARRED,
        banned: (flag & CARD_FLAG_BAN) === CARD_FLAG_BAN,
    };
}

class CardPreviewList {
    /**
     * @param view
     * @param {Texter} l18n
     * @param {Boolean} authenticated if user authenticated
     * @param {MoreCardsProvider} moreCardsProvider
     * @param {Array} cardFlags array of [cardId, cardFlags] pairs
     */
    constructor(view, l18n, authenticated, moreCardsProvider, cardFlags) {
        this.l18n = l18n;
        this.authenticated = authenticated;
        this.dataSource = moreCardsProvider;

        //>> save flags
        this.cardsFlags = {};
        cardFlags.forEach(([id, flags]) => {
            this.cardsFlags[id] = createCardFlagEntry(id, flags);
        });
        //<<  save flags

        this.list = view.find('ul');
        this.knownList = {};

        this.list.find('li').each((index, li) => {
            li = $(li);
            const item = new CardPreviewListItem(li.data('id'));
            item.li = li;
            item.sortAlpha = li.data('sort-alpha');
            this.knownList[item.id] = item;
        });

        this.sort = SORT_ORIGINAL;

        this.filter = 'all';
        this.filterSelect = view.find('select[name=plistModeSelect]');
        this.filterRadio = view.find('input[name=plistModeRadio]');

        this.filterSelect.change(() => {
            this._applyFilterChange(this.filterSelect.val());
        });

        this.filterRadio.change(() => {
            this._applyFilterChange(this.filterRadio.filter(':checked').val());
        });

        const cardSortSelect = view.find('[data-change=cardSort]');
        cardSortSelect.change(() => {
            this._applySort(cardSortSelect.val());
        });

        this.emptyListMessage = `<li class="fl-pack-plist__empty-item">${l18n.get('packPage.list.emptyMessage')}</li>`;

        this._initAudio();
        this._initFavouriteToggle();

        this.dataSourceLoadButton = $('button[data-click=loadMoreInList]').click(e => {
            const button = new ProgressButton(e.currentTarget);
            button.progress = true;
            this._loadMore()
                .finally(() => this._showListItems());
        });

        this._updateReviewButton();
        this._showPromo();
    }

    _initFavouriteToggle() {
        const listener = e => {
            const button = $(e.currentTarget), li = button.closest('li');
            const favouriteOn = !li.hasClass('fl-pack-plist__item--starred');

            const progress = new ProgressButton(button);
            progress.progress = true;

            const postParams = {
                card: li.data('id'),
                on: favouriteOn
            };
            $.post(`${Flashcards.root}/set/card/setFavourite.ajax`, postParams)
                .done(res => {
                    progress.progress = false;

                    const cardFlag = this.cardsFlags[postParams.card] || createCardFlagEntry(postParams.card, 0);

                    const newState = res.data;
                    if (newState) {
                        li.addClass('fl-pack-plist__item--starred');
                        button.find('span').attr('class', 'fa fa-star');
                        cardFlag.starred = true;
                    } else {
                        li.removeClass('fl-pack-plist__item--starred');
                        button.find('span').attr('class', 'fal fa-star');
                        cardFlag.starred = false;
                    }

                    this.cardsFlags[postParams.card] = cardFlag;
                });

            return stopEvent(e);
        };
        this.list.on('click', 'button[data-click=plistToggleFavourite]', listener);
    }

    _initAudio() {
        const audioCache = mapElementToValue('audio-cache', button => {
            const li = $(button).closest('li');
            return CardSound.multiSideButton(button,
                li.find('.fl-pack-plist__face'),
                li.find('.fl-pack-plist__back'));
        });

        this.list.on('click', 'button[data-click=plistPlayAudio]', e => {
            CardSound.stop();
            audioCache.get(e.currentTarget).toggle();
            return stopEvent(e);
        });
    }

    _applySort(sort) {
        this.sort = sort;
        this._showListItems();
    }

    _applyFilterChange(filterValue) {
        log(`current filter = ${filterValue}`);

        const radioValue = this.filterRadio.filter(':checked').val();
        if (radioValue !== filterValue) {
            this.filterRadio
                .parent().removeClass('active');
            this.filterRadio.filter(`[value=${filterValue}]`)
                .prop('checked', true)
                .parent().addClass('active');
        }

        const selectValue = this.filterSelect.val();
        if (selectValue !== filterValue) {
            this.filterSelect.val(filterValue);
        }

        this.filter = filterValue || 'all';

        this._showListItems();
    }

    _showListItems() {
        const self = this;

        /**
         * @param listName name of the list
         * @param predicate
         * @returns {Promise<*[]>}
         */
        function loadByFlagPromise(listName, predicate) {
            const set = Object.values(self.cardsFlags)
                .filter(entry => predicate(entry))
                .map(entry => entry.id);

            const unknowns = set.filter(value => !(value in self.knownList));

            // если все уже загружено - просто говорим ок
            if (unknowns.length === 0) {
                return Promise.resolve(set);
            }
            // иначе подгружаем недостающие и будем потом уже сортировать
            else {
                return self._loadMoreNamed(listName, set).then(() => {
                    return Promise.resolve(set)
                });
            }
        }

        /**
         * @returns {Promise<*[]>}
         */
        function loadKnown() {
            return Promise.resolve(Object.keys(self.knownList).map(k => parseInt(k)));
        }

        /**
         * @returns {Promise<*[]>}
         */
        function loadAll() {
            return self._loadMore().then(() => loadKnown());
        }

        let shortList = true;

        let loader;
        switch (this.filter) {
            case 'difficult':
                loader = loadByFlagPromise(this.filter, v => v.difficult);
                break;
            case 'familiar':
                loader = loadByFlagPromise(this.filter, v => v.familiar);
                break;
            case 'mastered':
                loader = loadByFlagPromise(this.filter, v => v.mastered);
                break;
            case 'starred':
                loader = loadByFlagPromise(this.filter, v => v.starred);
                break;
            default:
                shortList = false;
                loader = this.sort === SORT_ORIGINAL ? loadKnown() : loadAll();
                break;
        }

        let sorter = (a, b) => {
            a = Number(a.id);
            b = Number(b.id);
            return a - b;
        };

        if (this.sort === SORT_ALPHA) {
            sorter = (a, b) => {
                a = String(a.sortAlpha);
                b = String(b.sortAlpha);
                return a.localeCompare(b);
            };
        }

        loader.then(set => {
            const cards = set
                .map(id => this.knownList[id] || null)
                .filter(entry => entry != null)
                .sort(sorter)
                .map(card => card.li);

            this.list
                .empty()
                .append(cards);

            if (cards.length === 0) {
                this.list.append(this.emptyListMessage);
            }

            this._updateReviewButton();

            // если это частичный список (starred, familiar и т.д.), то кнопка не нужна - все загружено
            // если это полный список, то кнопка может и понадобится еще
            this.dataSourceLoadButton.toggle(!shortList);
        });
    }

    _showPromo() {
        // и показываем survey
        if (promo.enabled) {
            const surveyContainer = $('<li class="px-lg-2 mb-2 panel"/>');
            promo.show(surveyContainer);

            const surveyInsert = this.list.find('> li:nth-child(1)');
            if (surveyInsert && surveyInsert.length) {
                surveyInsert.after(surveyContainer);
            } else {
                this.list.prepend(surveyContainer);
            }
        }
    }

    _updateReviewButton() {
        const reviewAnchor = $('a[data-bind=reviewHref]');
        const reviewAnchorHrefPrefix = reviewAnchor.data('href-prefix');
        reviewAnchor
            .attr('href', reviewAnchorHrefPrefix + (this.filter.length ? `/${this.filter}` : ''))
            .toggleClass('disabled', this.list.children().length < 2 || this.filter === 'all');
    }

    _loadConsume(cards) {
        const unknowns = cards.filter(v => !(v.id in this.knownList));
        if (unknowns.length === 0) {
            return;
        }

        const html = CARD_PREVIEW_ITEMS_TEMPLATE.render({
            cards: unknowns,
            authenticated: this.authenticated
        }, this);

        this.list.append(html);

        unknowns.forEach(value => {
            const item = new CardPreviewListItem(value.id);
            item.sortAlpha = value.faceText;
            this.knownList[item.id] = item;
        });

        // если добавляется больше 20 элементов, то быстрее будет пройти по списку
        // и вручную проставть <li>, чем потом искать по #id
        if (unknowns.length > 20) {
            const self = this;
            this.list.find('li.fl-pack-plist__item').each(function () {
                const el = $(this);
                const id = el.data('id');
                self.knownList[id].li = el;
            });
        }

        // если все уже подгружено - удаляем кнопку load more
        if (this.dataSource != null && Object.keys(this.knownList).length >= this.dataSource.size) {
            this.dataSource = null;
            this.dataSourceLoadButton.remove();
        }
    }

    _loadMore() {
        if (this.dataSource == null) {
            return Promise.resolve([]);
        }

        return this.dataSource
            .load()
            .then(
                list => {
                    this._loadConsume(list);
                },
                () => {
                }
            );
    }

    _loadMoreNamed(listName, idList) {
        if (this.dataSource == null) {
            return Promise.resolve([]);
        }

        return this.dataSource
            .loadNamedList(listName, idList)
            .then(
                list => {
                    this._loadConsume(list);
                },
                error => {
                }
            );
    }
}

class PackActions {
    constructor(packId, l18n) {
        $('button[data-click=toggleHeaderActions]').click(() => {
            $('.fl-pack-header').toggleClass('fl-pack-header--actions-open');
        });

        $('#doAddToCollection').click(function () {
            const btn = new ProgressButton(this);
            btn.progress = true;

            new PackAddToCollectionAction({
                packId: packId,
                l18n: l18n,
                modalShown: function () {
                    btn.progress = false;
                }
            }).execute();
        });

        $('#doAddToSaved').click(function () {
            const btn = new ProgressButton(this);
            btn.progress = true;

            $.post(`${Flashcards.root}/set/${packId}/add-to-favourites.ajax`)
                .done(() => {
                    btn.el.remove();
                })
                .fail((xhr) => {
                    if (xhr.status !== 403) {
                        return;
                    }
                    Modaller.showForbidden(l18n, 'packPage.dialogs.addToFavourites.title', 'packPage.dialogs.addToFavourites.forbidden');
                });
        });

        $('#doClone').click(function () {
            const btn = new ProgressButton(this);
            btn.progress = true;

            new PackCloneAction({
                packId: packId,
                l18n: l18n,
                modalShown: function () {
                    btn.progress = false;
                }
            }).execute();
        });

        $('#doShare').click(function () {
            const btn = new ProgressButton(this);
            btn.progress = true;

            new PackShareCommand({
                packId: packId,
                l18n: l18n,
                modalShown: function () {
                    btn.progress = false;
                }
            }).execute();
        });
    }
}

class PackPage {
    constructor(opts) {
        const themeRoot = opts.themeRoot;
        const packId = opts.packId;
        const l18n = Texter.create(opts.l18n);
        const cardFlags = opts.cardFlags || [];

        const cardsProvider = opts.cardsMore ? new MoreCardsProvider(packId, opts.cardCount) : null;

        new PackActions(packId, l18n);
        new CardPreviewList($('#cardList'), l18n, opts.authenticated, cardsProvider, cardFlags);
        new CardEmbed($('#embedView'), l18n, cardsProvider);

        if (!opts.authenticated) {
            new PackPagePromo({l18n});
        }
    }
}

class MoreCardsProvider {
    constructor(packId, size) {
        this.packId = packId;
        this.list = null;
        this.size = size;
        this.listNamed = {};
    }

    load() {
        if (this.list != null) {
            return Promise.resolve(this.list);
        }
        return aPromise($.get(`${Flashcards.root}/set/${this.packId}/cards.ajax`))
            .then(
                list => this.list = list,
                error => this.list = []
            );
    }

    loadNamedList(listName, idList) {
        if (listName in this.listNamed) {
            return Promise.resolve(this.listNamed[listName]);
        }

        if (this.list != null) {
            const desired = new Set();
            idList.forEach(item => desired.add(item));
            const result = this.list.filter(item => desired.has(item.id));
            return Promise.resolve(result);
        }
        const ajax = {
            type: "POST",
            url: `${Flashcards.root}/set/${this.packId}/cards-slice.ajax`,
            data: JSON.stringify(idList),
            contentType: "application/json; charset=utf-8",
            dataType: "json"
        };
        return aPromise($.ajax(ajax))
            .then(
                list => this.listNamed[listName] = list,
                error => this.listNamed[listName] = []
            );
    }
}

global.PackPage = PackPage;